import React, { useState } from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import
{
    faChevronRight,
    faChevronDown
}
from "@fortawesome/free-solid-svg-icons";

const DATA =
[
    {
        id:1,
        name:"Compliance",
        expanded:true,
        checked:true,
        children:
        [
            {id:11,name:"Fire",checked:true},
            {id:12,name:"Asbestos",checked:true},
            {id:13,name:"Legionella",checked:true},
            {id:14,name:"Health & Safety",checked:false}
        ]
    },

    {
        id:2,
        name:"Engineering",
        expanded:true,
        checked:true,
        children:
        [
            {id:21,name:"Mechanical",checked:true},
            {id:22,name:"Electrical",checked:true},
            {id:23,name:"HVAC",checked:true}
        ]
    },

    {
        id:3,
        name:"Operations",
        expanded:false,
        checked:true,
        children:
        [
            {id:31,name:"Cleaning",checked:true},
            {id:32,name:"Security",checked:true}
        ]
    },

    {
        id:4,
        name:"Drawings",
        expanded:true,
        checked:true,
        children:
        [
            {id:41,name:"Floor Plans",checked:true},
            {id:42,name:"Elevations",checked:true},
            {id:43,name:"Sections",checked:true}
        ]
    },

    {
        id:5,
        name:"Media",
        expanded:false,
        checked:true,
        children:
        [
            {id:51,name:"Images",checked:true},
            {id:52,name:"Videos",checked:true}
        ]
    }
];

export default function ClassificationFilterDrawer(
{
    displayFlag,
    closeFunction,
    selectedItems,
    setSelectedItems
})
{
    const [nodes,setNodes] =
        useState(DATA);

    function toggleExpand(id)
    {
        setNodes(
            nodes.map(n =>
                n.id===id
                ?
                {...n,expanded:!n.expanded}
                :
                n
            )
        );
    }

    function toggleParent(id)
    {
        setNodes(
            nodes.map(n =>
            {
                if(n.id!==id)
                    return n;

                return {
                    ...n,
                    checked:!n.checked,
                    children:
                        n.children.map(c=>(
                        {
                            ...c,
                            checked:!n.checked
                        }))
                };
            })
        );
    }

    function toggleChild(parentId,id)
    {
        setNodes(
            nodes.map(n=>
            {
                if(n.id!==parentId)
                    return n;

                return{
                    ...n,
                    children:
                        n.children.map(c=>
                            c.id===id
                            ?
                            {...c,checked:!c.checked}
                            :
                            c
                        )
                };
            })
        );
    }

	return (

	    <div
	        style={{

	            position: "fixed",

	            top: 0,
	            right: 0,

	            width: "360px",
	            height: "100vh",

	            transform:
	                displayFlag
	                    ? "translateX(0)"
	                    : "translateX(105%)",

	            transition:
	                "transform .45s cubic-bezier(.22,.61,.36,1)",

	            background:
	                "linear-gradient(180deg,#23272f 0%,#171b20 100%)",

	            backdropFilter: "blur(24px)",

	            borderLeft:
	                "1px solid rgba(255,255,255,.08)",

	            boxShadow:
	                "-20px 0 45px rgba(0,0,0,.45)",

	            overflowY: "auto",
				overflowX:"visible",

	            color: "white",

	            zIndex: 100000
	        }}
	    >

	        {/* Close Button */}

	        <div
	            onClick={closeFunction}

	            style={{

	                position: "absolute",

	                left: "-17px",
	                top: "18px",

	                width: "34px",
	                height: "34px",

	                borderRadius: "50%",

	                display: "flex",
	                alignItems: "center",
	                justifyContent: "center",

	                cursor: "pointer",

	                background:
	                    "rgba(28,32,40,.98)",

	                border:
	                    "1px solid rgba(255,255,255,.12)",

	                color: "white",

	                boxShadow:
	                    "0 10px 24px rgba(0,0,0,.45)"
	            }}
	        >

	            <FontAwesomeIcon
	                icon={faChevronRight}
	            />

	        </div>

	        {/* Header */}

	        <div
	            style={{

	                height: "58px",

	                display: "flex",

	                alignItems: "center",

	                paddingLeft: "24px",

	                fontSize: "18px",

	                fontWeight: 600,

	                borderBottom:
	                    "1px solid rgba(255,255,255,.08)"
	            }}
	        >

	            Classification

	        </div>

	        {/* Tree */}

	        <div
	            style={{

	                padding: "18px"

	            }}
	        >

	            {

	                nodes.map(parent =>

	                    <div key={parent.id}>

	                        {/* Parent */}

	                        <div
	                            style={{
	                                display: "flex",
	                                alignItems: "center",
	                                height: "34px",
	                                color: "white"
	                            }}
	                        >

	                            <div
	                                style={{
	                                    width: "18px",
	                                    cursor: "pointer"
	                                }}

	                                onClick={() =>
	                                    toggleExpand(parent.id)
	                                }
	                            >

	                                <FontAwesomeIcon
	                                    icon={
	                                        parent.expanded
	                                            ? faChevronDown
	                                            : faChevronRight
	                                    }
	                                />

	                            </div>

	                            <input
	                                type="checkbox"
	                                checked={parent.checked}

	                                onChange={() =>
	                                    toggleParent(parent.id)
	                                }
	                            />

	                            <span
	                                style={{
	                                    marginLeft: "10px",
	                                    fontSize: "13px"
	                                }}
	                            >
	                                {parent.name}
	                            </span>

	                        </div>

	                        {

	                            parent.expanded &&

	                            parent.children.map(child =>

	                                <div
	                                    key={child.id}

	                                    style={{
	                                        display: "flex",
	                                        alignItems: "center",
	                                        marginLeft: "30px",
	                                        height: "28px",
	                                        color: "rgba(255,255,255,.82)"
	                                    }}
	                                >

	                                    <input
	                                        type="checkbox"
	                                        checked={child.checked}

	                                        onChange={() =>
	                                            toggleChild(
	                                                parent.id,
	                                                child.id
	                                            )
	                                        }
	                                    />

	                                    <span
	                                        style={{
	                                            marginLeft: "10px",
	                                            fontSize: "12px"
	                                        }}
	                                    >
	                                        {child.name}
	                                    </span>

	                                </div>

	                            )

	                        }

	                    </div>

	                )

	            }

	        </div>

	    </div>

	);

}